export class ListValue {
  public id: string;
  public label: string;

  constructor(init?: Partial<ListValue>) {
    Object.assign(this, init);
  }
}
